import { DronePageReducer } from "./redux";

export const DroneFeatureMiddlewares: [] = [];

export const DroneFeatureReducers = {
  DronePageReducer,
};
